const SECONDS_IN_AN_HOUR = 3600;

export function computeHoursInSeconds(seconds: number): number {
  return Math.floor(seconds / SECONDS_IN_AN_HOUR);
}

export function computeSecondsInHours(hours: number): number {
  return hours * SECONDS_IN_AN_HOUR;
}
